export default __webpack_public_path__ + "static/media/twitter.40939c02.svg";